<template>
  <div>
    <auth-title label="Update data" />

    <auth-salutation v-model="value.salutation" :error="error.salutation" @input="updateValue" />

    <auth-group>
      <auth-input style="width: 15em" type="text" name="lastname" label="Vorname" v-model="value.lastname" :error="error.lastname" @input="updateValue"/>

      <auth-input style="width: 15em" type="text" name="firstname" label="Name" v-model="value.firstname" :error="error.firstname" @input="updateValue"/>
    </auth-group>

    <auth-group>
      <auth-input style="width: 8em" type="text" name="zip" label="PLZ" v-model="value.zip" :error="error.zip" @input="updateValue" />

      <auth-input style="width: 22em" type="text" name="city" label="Ort" v-model="value.city" :error="error.city" @input="updateValue" />
    </auth-group>

    <auth-group>
      <auth-input style="width: 22em" type="text" name="street" label="Straße" v-model="value.street" :error="error.street" @input="updateValue" />

      <auth-input style="width: 8em" type="text" name="streetnumber" label="Nr" v-model="value.streetnumber" :error="error.streetnumber" @input="updateValue" />
    </auth-group>

    <auth-captcha v-if="showCaptcha" :state="state" @update="update" />

    <auth-button label="WEITER" @click="submit" />
  </div>
</template>

<script>
import Api from "../api/api";
import Validator, { emailRegex } from "./validator";
import AuthSalutation from "@/components/plenigo-auth/components/auth-salutation";
import AuthInput from "@/components/plenigo-auth/components/auth-input";
import AuthButton from "@/components/plenigo-auth/components/auth-button";
import AuthGroup from "@/components/plenigo-auth/components/auth-group";
import AuthCaptcha from "@/components/plenigo-auth/components/auth-captcha";

export default {
  components: { AuthGroup, AuthSalutation, AuthInput, AuthButton, AuthCaptcha },
  props: {
    state: Object
  },
  methods: {
    update(property, value) {
      this.$emit("update", property, value);
    },
    async submit() {
      this.update("errorMessage", undefined);
      if (
        !Validator.validate(
          {
            salutation: "^(Frau|Herr)$",
            lastname: "^[A-z]+$",
            firstname: "^[A-z]+$",
            zip: "^[0-9]{5}$",
            city: ".+",
            street: ".+",
            streetnumber: ".+",
          },
          this.value,
          this.error
        )
      ) {
        return;
      }

      const update = await Api.userUpdate(this.value);

      if (!update.success) {
        if (update.message === "Ungültiger Sicherheitscode") {
          this.showCaptcha = true;
        }
        this.update("errorMessage", update.message);
        return;
      }

      this.updateValue();
      this.update("currentStep", "finished");
    },
    updateValue() {
      this.update("value", this.value);
    }
  },
  data() {
    return {
      value: {
        salutation: (this.state.value && this.state.value.salutation) || "",
        lastname: (this.state.value && this.state.value.lastname) || "",
        firstname: (this.state.value && this.state.value.firstname) || "",
        zip: (this.state.value && this.state.value.zip) || "",
        city: (this.state.value && this.state.value.city) || "",
        street: (this.state.value && this.state.value.street) || "",
        streetnumber: (this.state.value && this.state.value.streetnumber) || "",
        username: (this.state.value && this.state.value.username) || "",
        password: (this.state.value && this.state.value.password) || ""
      },
      error: {
        salutation: false,
        lastname: false,
        firstname: false,
        zip: false,
        city: false,
        street: false,
        streetnumber: false,
        username: false,
        password: false
      },
      showCaptcha: false
    };
  }
};
</script>
